import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { MethodService } from '@/infra/services/method';
import type { UpdateMethodResponseDTO } from '@/core/dto/method';

interface UpdateMethodParams {
	organization_id?: string;
	company_id?: string;
	id: string;
	name: string;
	description: string;
}

const Service = MethodService.getInstance();

export const useUpdateMethod = () => {
	const queryClient = useQueryClient();
	return useMutation<UpdateMethodResponseDTO, AxiosError<Response>, UpdateMethodParams>({
		mutationFn: async (params) => Service.update(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_METHOD_LIST_OPTIONS]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_METHOD]);
			message.success(I18n.get('Method updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Failed to update method'));
		}
	});
};
